<template>
    <div class="bg-education text-white py-2 px-4 text-center d-flex align-items-center justify-content-between gap-75">
        <div class="d-inline-flex justify-content-center align-items-center gap-75 flex-wrap">
            <i class="far fa-graduation-cap font-size-200"></i>

            <span v-html="description"></span>

            <div class="gap-75 d-inline-flex align-items-center justify-content-center flex-wrap">
                <ButtonWithLoadingState
                    class="btn btn-warning font-weight-bold"
                    :text="buttonText"
                    :is-state-loading="stateLoading"
                    @click.stop.prevent="requestEducationConfirmationMail"
                ></ButtonWithLoadingState>

                <a :href="linkEducation" class="text-white text-underline">{{ translate('Learn more') }}</a>
            </div>
        </div>

        <span class="pull-right font-size-200 cursor-pointer notification-close" @click.stop.prevent="dismiss"></span>
    </div>
</template>

<script>
import { USER_NOTIFICATION_HIDE, USER_NOTIFICATIONS } from './user-notifications';
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter.vue';
import { User } from '../user';
import ButtonWithLoadingState from '../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState.vue';
import { userManager } from '../user-manager';
import { pageNotification } from '../../../qaamgo/helper/notify';
import { globalLogger } from '../../../qaamgo/helper/global-logger';
import { setCookie } from '../../../qaamgo/helper/cookie';
import { eventBus } from '../../../lib/event-bus/event-bus';

export default {
    name: USER_NOTIFICATIONS.EDUCATION_EXPIRED,
    components: { ButtonWithLoadingState },
    mixins: [TransFilter],
    props: {
        data: {
            type: User | null,
            default: null,
        },
    },
    mounted() {
        globalLogger.log('edu renew banner - show');
    },
    computed: {
        linkEducation() {
            return window.sat.educationUrl;
        },
        description() {
            if (this.mailSent) {
                return this.translate(
                    "We've sent a confirmation email to <strong>%1</strong>. Time to check your inbox!",
                    {
                        '%1': this.data?.getPlainEmail() ?? '',
                    }
                );
            }

            return this.translate(
                'Keep your education journey going! Verify your email now to renew your free educational access.'
            );
        },
        buttonText() {
            if (this.mailSent) {
                return this.translate('Send again');
            }

            return this.translate('Verify now');
        },
    },
    methods: {
        async requestEducationConfirmationMail() {
            this.stateLoading = true;
            globalLogger.log('edu renew banner - request mail start');

            try {
                await userManager.sendEducationalConfirmationMail();
                globalLogger.log('edu renew banner - request mail success');

                this.mailSent = true;
            } catch (e) {
                pageNotification.showGenericErrorMessage();
                globalLogger.log('edu renew banner - request mail fail');
            } finally {
                setTimeout(() => {
                    this.stateLoading = false;
                }, 5000);
            }
        },
        dismiss() {
            globalLogger.log('edu renew banner - dismiss');

            // do not annoy user for one week
            const cookieTTL_s = 60 * 60 * 24 * 7;

            setCookie('user-edu-renew-banner-dismiss', true, cookieTTL_s);

            eventBus.emit(USER_NOTIFICATION_HIDE, USER_NOTIFICATIONS.EDUCATION_EXPIRED);
        },
    },
    data() {
        return {
            stateLoading: false,
            mailSent: false,
        };
    },
};
</script>

<style scoped lang="scss">
.notification-close:before,
.notification-close:after {
    position: absolute;
    left: 12px;
    content: ' ';
    height: 1.5rem;
    width: 2px;
    background-color: #fff;
}

.notification-close:before {
    transform: rotate(45deg);
}

.notification-close:after {
    transform: rotate(-45deg);
}

.notification-close {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}
</style>
